import React from "react";
import "./newlaunch.scss";
import pasadena from "./pasadena.json";
import Cardrumah from "../../component/cardrumah/cardrumah.jsx";
import {
  Aira,
  Byra,
  Celia,
  Elysia,
  Kiana,
  Nara,
} from "../../asset/pasadena/pasadena.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ilonacarousel from "../../asset/newlaunch/carousel/ilonacarousel.js";
const imageMap = {
  Aira,
  Byra,
  Celia,
  Elysia,
  Kiana,
  Nara, // Add other image arrays here if you have more sets
};

const Newlaunch = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyload: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768, // Adjust breakpoint for your mobile size
        settings: {
          slidesToShow: 1,
          arrows: false,
          lazyload: true,
          autoplay: true, // Show only 1 slide on mobile screens
        },
      },
    ],
  };
  return (
    <div id="newlaunch" className="newlaunch">
      <div className="container-newlaunch">
        <div className="header-newlaunch">
          <div className="judul-newlaunch">NEW LAUNCHING</div>
        </div>
        <div className="newflyer"></div>
        <div className="carousel-newlaunch">
          <Slider {...settings}>
            {ilonacarousel.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt="fasilitas"
              />
            ))}
          </Slider>
        </div>
        <div className="cardhome-container">
          {pasadena.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Newlaunch;
